<template>
    <div class="col-xs-12">
        <Spinner v-if="isSendingInvoice" v-bind:title="'Sending Invoice Please wait...'|trans"  ></Spinner>
        <div class="sent-invoice-done alert alert-success" v-if="isInvoiceSent">
            {{'Your invoice has been sent! '|trans}}

            <button class="btn btn-primary" @click="$emit('gotoNextStep')">{{'Next Step'|trans}}</button>

        </div>

        <div class="send-invoice-form" v-if="!isInvoiceSent && !isSendingInvoice">
            <div class="no-padding-bottom no-margin-bottom">
                <h4>{{'Send invoice to customer'|trans}}</h4>
            </div>

            <div class="form-group">
                <label for="customer_email">{{'Customer Email'|trans}}</label>
                <input v-model="job.customer.email" class="form-control" id="customer_email">
            </div>

            <div class="form-group">
                <label>{{'Billing Information'|trans}}</label>
                <CustomerAddress v-model="job.customer" v-on:new_address="newAddress" v-bind:showOnly="false"></CustomerAddress>
            </div>

            <button class="btn btn-primary" @click="submitInvoice">{{'Send invoice to customer'|trans}}</button>
        </div>
    </div>
</template>

<script>

    import CustomerAddress from "./CustomerAddress/CustomerAddress";
    import Spinner from "./Spinner";


    export default {
        components: {Spinner, CustomerAddress},
        props: {
            job:Object
        },
        data() {
            return {
                isSendingInvoice : false,
                isInvoiceSent : false
            }
        },
        created(){

        },
        methods: {
            newAddress(newAddressData) {
                this.job.customer.address.push(Object.assign({}, newAddressData));
                this.job.customer.address_selected_id = newAddressData.id;
            },
            async submitInvoice(){
                if(navigator.onLine){
                    this.job.workerIntervention.pureContact.isInvoiceSent = true;
                    this.isSendingInvoice= true;
                    await this.$api.invoice.addInvoiceAndSendByEmailToCustomer(this.job);
                    this.isSendingInvoice = false;
                    this.isInvoiceSent = true;
                    setTimeout(() => this.$emit('gotoNextStep'), 2000);
                } else {
                    alert('Not internet connection try later');
                }
            }
        },
        watch:{

        }
    }

</script>

